// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/SimilarPatients/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Calendar_New_AppointmentOverlay_Content_New_SimilarPatients_Content(
  $first_name: String!
  $last_name: String!
  $birth_date: date
  $birth_date_s: String
) {
  vaxiom_persons(
    where: {
      first_name: { _eq: $first_name }
      last_name: { _eq: $last_name }
      birth_date: { _eq: $birth_date }
    }
  ) {
    id: _id
    vaxiom_id: id
    first_name
    middle_name
    last_name
    title
    greeting
    gender
    ssn
    school
    birth_date
    patient {
      _id
      human_readable_id
      legacy_id
    }
    contact_method_associations(
      limit: 1
      where: { postal_address: { state: { _is_null: false } } }
    ) {
      postal_address {
        city
        state
      }
    }
  }

  leads_leads(
    where: {
      first_name: { _ilike: $first_name }
      last_name: { _ilike: $last_name }
      birth_date: { _eq: $birth_date_s }
      patient_id: { _is_null: true }
    }
  ) {
    id
    first_name
    last_name
    birth_date
  }
}

`